import { CatalogIndexPage } from '@backstage/plugin-catalog';
import { EntityRefLink } from '@backstage/plugin-catalog-react';
import { OverflowTooltip } from '@backstage/core-components';

import {
  EntityKindPicker,
  EntityTypePicker,
} from '@backstage/plugin-catalog-react';

export const ScoreCards = () => {
  return (
    <CatalogIndexPage
      filters={
        <>
          <EntityKindPicker initialFilter="Group" allowedKinds={['Group']} />
          <EntityTypePicker initialFilter="department" />
        </>
      }
      tableOptions={{ draggable: false }}
      columns={[
        {
          title: 'Name',
          field: 'resolved.entityRef',
          highlight: true,
          render: ({ entity }) => (
            <EntityRefLink entityRef={entity} defaultKind="Group" />
          ),
        },
        {
          title: 'Type',
          field: 'entity.spec.type',
        },
        {
          title: 'Description',
          field: 'entity.metadata.description',
          render: ({ entity }) => (
            <OverflowTooltip
              text={entity.metadata.description}
              placement="bottom-start"
            />
          ),
        },
      ]}
    />
  );
};
